import { render } from "./ChatbotStep1.vue?vue&type=template&id=c436212a"
import script from "./ChatbotStep1.vue?vue&type=script&lang=js"
export * from "./ChatbotStep1.vue?vue&type=script&lang=js"

import "./ChatbotStep1.vue?vue&type=style&index=0&id=c436212a&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__